import {FieldUtil} from "base/ui/section/utilities";
import {DateUtil} from "base/format/utilities";

import {PERMIT_EXTENSION_STATUS} from "permitextension/data";
import {usePermitExtensionProcessUrl} from "permitextension/hooks";
import {PermitTypeTags} from "permit/presentational";
import {SectionCard} from "base/ui/section/components";
import Grid from "@mui/material/Grid";

const PermitExtensionGeneralDataSection = ({element}) => {
    const basePath = `/permits/extensions/list/${element?.id}`;

    const {getStepPath} = usePermitExtensionProcessUrl(element);
    const stepPath =
        element.status === PERMIT_EXTENSION_STATUS.not_approved
            ? null
            : getStepPath(element, basePath);

    return (
        <SectionCard title="Informações gerais">
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    {FieldUtil.getSectionField(
                        "Autorização",
                        element?.permit?.code,
                        null,
                        null,
                        `/permits/approved/list/${element?.permit?.id}`
                    )}
                    {FieldUtil.getSectionField(
                        "Estado",
                        element?.status,
                        null,
                        null,
                        stepPath
                    )}
                </Grid>
                <Grid item xs={6}>
                    {FieldUtil.getSectionField(
                        "Data de solicitação",
                        DateUtil.formatDate(element?.application_date)
                    )}
                    {FieldUtil.getSectionField(
                        "Guias prorrogadas",
                        element?.types?.length ? (
                            <PermitTypeTags types={element.types} />
                        ) : null
                    )}
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default PermitExtensionGeneralDataSection;
